const AuthUtils = {
    minPasswordLength: 8,
}

export default AuthUtils;



// WEBPACK FOOTER //
// ./src/utils/AuthUtils.js